import React from 'react'
import { Logo, LogoProps } from '@deal/components'
import { HostnameConsumer, Hostname } from '#src/containers/Hostname'

const BrandAwareLogo: React.SFC<LogoProps> = props => (
  <HostnameConsumer>
    {hostname => <Logo brand={hostname === Hostname.Curated ? 'curated' : 'deal'} {...props} />}
  </HostnameConsumer>
)

export default BrandAwareLogo
